<template>
  <div
    class="py-10 lg:py-20 px-4 bg-semantic-surface-default"
    :data-testid="dataTestid"
  >
    <div class="max-w-wrapper-lg mx-auto">
      <p
        v-if="$slots.header"
        class="text-2xl/[120%] md:text-4xl/[120%] text-center text-semantic-surface-on-surface font-semibold"
        :class="{
          'md:mb-4 mb-2': $slots['sub-header'],
        }"
      >
        <slot name="header" />
      </p>

      <p
        v-if="$slots['sub-header']"
        class="md:text-lg text-center text-semantic-surface-on-surface"
      >
        <slot name="sub-header" />
      </p>

      <div class="flex flex-col md:grid md:grid-cols-3 gap-y-6 md:gap-8 md:mt-10 mt-6">
        <V2MoleculesCardFeatureCard
          v-for="(guide, guideKey) in guides"
          :key="guideKey"
          header-icon=""
          :title="guide.title"
          :description="guide.content"
          :image-path="guide.imageUrl"
          class="w-full !max-w-full"
        >
          <template #footer>
            <V2AtomsButton
              has-icon-right
              theme="tertiary"
              size="small"
              :inverted="false"
              :to="guide.pageUrl"
            >
              Learn more
            </V2AtomsButton>
          </template>
        </V2MoleculesCardFeatureCard>

        <V2AtomsButton
          ref="loadmore"
          theme="tertiary"
          size="large"
          class="col-start-2"
          :has-icon-right="true"
          icon-direction="bottom"
          :to="props.actionButtonUrl"
        >
          Load more
        </V2AtomsButton>
      </div>
    </div>
  </div>
</template>

<script setup>
import { arrayObjectPropValidator } from '~/helpers/validator'

defineOptions({
  name: 'V2OrganismHomeGuideTiles'
})

const props = defineProps({
  dataTestid: {
    type: String,
    default: ''
  },
  guides: {
    type: Array,
    required: true,
    validator: value =>
      arrayObjectPropValidator(value, [
        'title',
        'content',
        'imageUrl',
        'pageUrl'
      ])
  },

  actionButtonUrl: {
    type: String,
    required: true
  },

  imageLazyLoad: {
    type: Boolean,
    default: false
  }
})
</script>
